import { render, staticRenderFns } from "./SubscriptionFeeComponent.vue?vue&type=template&id=5b71fb91&"
import script from "./SubscriptionFeeComponent.vue?vue&type=script&lang=js&"
export * from "./SubscriptionFeeComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports